import { useContext, useState } from "react";
import { Box, List } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { LayoutContext } from "../../context/LayoutContext";

import { menuItems } from "../../config/sidebarMenuConfig";
import { settingsMenu } from "../../config/settingsMenuConfig";
import { leadsAnalyticsMenu } from "../../config/leads.settings";

import SidebarHeader from "./SidebarHeader";
import SidebarBack from "./SidebarBack";
import SidebarItem from "./SidebarItem";
import SidebarLogout from "./SidebarLogout";

export default function SidebarContent({ overlay = false }) {
  const theme = useTheme();
  const { collapsed } = useContext(LayoutContext);
  const [mode, setMode] = useState("main");

  const activeMenu =
    mode === "leads"
      ? leadsAnalyticsMenu
      : mode === "settings"
      ? settingsMenu
      : menuItems;

  const hideSections = collapsed && !overlay;

  return (
    <Box
      sx={{
        width: overlay ? 280 : collapsed ? 80 : 280,
        height: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <SidebarHeader
        overlay={overlay}
        isSettings={mode === "settings"}
        isAnalytics={mode === "leads"}
      />

      <List
        sx={{
          mt: 1,
          flexGrow: 1,
          overflowY: "auto",
          // Main sidebar scrollbar - black background
          "&::-webkit-scrollbar": {
            width: "8px",
          },
          "&::-webkit-scrollbar-track": {
            background: "#000",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: theme.palette.primary.main,
            borderRadius: "8px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: theme.palette.primary.dark,
          },
          scrollbarWidth: "thin",
          scrollbarColor: `${theme.palette.primary.main} #000`,
        }}
      >
        {mode !== "main" && (
          <SidebarBack overlay={overlay} onClick={() => setMode("main")} />
        )}

        {activeMenu.map((item, index) => {
          const showSection =
            !hideSections &&
            item.section &&
            item.section !== activeMenu[index - 1]?.section;

          return (
            <Box key={item.key || index}>
              {showSection && (
                <Box
                  sx={{
                    px: 3,
                    mt: 2,
                    mb: 0.5,
                    fontSize: 11,
                    opacity: 0.6,
                    color: "#fff",
                  }}
                >
                  {item.section}
                </Box>
              )}

              <SidebarItem
                item={item}
                index={index}
                menu={activeMenu}
                overlay={overlay}
                mode={mode}
                setMode={setMode}
              />
            </Box>
          );
        })}
      </List>

      <List
        disablePadding
        sx={{
          py: 0,
        }}
      >
        <SidebarLogout />
      </List>
    </Box>
  );
}
